var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('base-rabota-agro-university-card',{staticClass:"university-card",attrs:{"id":_vm.universityCard.id,"name":_vm.universityCard.name,"image":_vm.universityCard.image,"programs":_vm.universityCard.programs,"price":_vm.universityCard.price},on:{"on-click-card":function($event){return _vm.clickCard(_vm.universityCard)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }